import { Alert, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { DashboardNotifcation } from "./types";

export interface DashboardNotifcationProps {
	notification: DashboardNotifcation | undefined;
}

const DashboardNotification: React.FC<DashboardNotifcationProps> = ({ notification }) => {
	const [open, setIsOpen] = useState<boolean>(false);

	useEffect(() => {
		setIsOpen(notification != undefined);
	}, [notification]);

	const handleSnackBarClose = () => {
		setIsOpen(false);
	};

	return (
		<>
			{notification && (
				<Snackbar
					open={open}
					autoHideDuration={notification.duration | 5000}
					onClose={handleSnackBarClose}
					anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
					action={
						<IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackBarClose}>
							<CloseIcon fontSize="small" />
						</IconButton>
					}
				>
					<Alert
						onClose={handleSnackBarClose}
						severity={notification.severity ? notification.severity : "success"}
						sx={{
							width: "100%",
							color: "white",
							maxWidth: "500px",
							backgroundColor: notification.severity === "error" ? "darkred" : "darkgreen",
						}}
					>
						{notification.message}
					</Alert>
				</Snackbar>
			)}
		</>
	);
};

export default DashboardNotification;
